export const publicRoot = '/public';
export const homeRequerimento = '/public/Requerimento';
export const privateRoot = '/private';
export const notFound = '/404';
export const semAcesso = `${privateRoot}/FasAcessoNegado`;

export const rotaAtendente = `${privateRoot}/Atendente`;
export const homeContribuinte = `${privateRoot}/Contribuinte`;

export const servicos = `${publicRoot}/servicos`;
export const duvidas = `${publicRoot}/duvidas`;

export const pesquisarProtocolo = `${publicRoot}/consultarRequerimento`;
export const detalharRequerimentoContribuinte = `${publicRoot}/DetalharRequerimentoContribuinte`;

export const requerimentos = `${privateRoot}/Requerimentos`;
export const requerimentosListarContribuinte = `${privateRoot}/RequerimentosListarContribuinte`;
export const detalharRequerimento = `${privateRoot}/DetalharRequerimento`;
export const resumoRequerimento = `${publicRoot}/ResumoRequerimento`;
export const comprovanteRequerimento = `${publicRoot}/ComprovanteRequerimento`;

export const cadastroAtendente = `${privateRoot}/CadastrarAtendente`;
export const editarAtendente = `${privateRoot}/EditarAtendente`;
export const visualizarAtendente = `${privateRoot}/VisualizarAtendente`;
export const listarAtendente = `${privateRoot}/ListarAtendente`;

export const dicionario = `${privateRoot}/DicionarioFas`;

export const servicosSistemaCadastrar = `${privateRoot}/servicosSistemaCadastrar`;
export const servicosSistemaListar = `${privateRoot}/servicosSistemaListar`;
export const servicosSistemaDetalhar = `${privateRoot}/servicosSistemaDetalhar`;
export const servicosSistemaEditar = `${privateRoot}/servicosSistemaEditar`;

export const postosAtendimentoCadastrar = `${privateRoot}/postosAtendimentoCadastrar`;
export const postosAtendimentoListar = `${privateRoot}/postosAtendimentoListar`;
export const postosAtendimentoDetalhar = `${privateRoot}/postosAtendimentoDetalhar`;
export const postosAtendimentoEditar = `${privateRoot}/postosAtendimentoEditar`;

export const setorSistemaCadastrar = `${privateRoot}/setorSistemaCadastrar`;
export const setorSistemaListar = `${privateRoot}/setorSistemaListar`;
export const setorSistemaEditar = `${privateRoot}/setorSistemaEditar`;
export const setorSistemaDetalhar = `${privateRoot}/setorSistemaDetalhar`;

export const relatorioStatus = `${privateRoot}/RelatorioStatus`;
export const relatorioSolicitacoes = `${privateRoot}/RelatorioSolicitacoes`;
export const relatorioTipo = `${privateRoot}/RelatorioTipo`;
export const relatorioPerformanceGeral = `${privateRoot}/RelatorioPerformanceGeral`;
export const relatorioPerformanceAtendente = `${privateRoot}/RelatorioPerformanceAtendente`;
export const relatorioListarRequerimentos = `${privateRoot}/RelatorioListarRequerimentos`;

export const dadosCadastraisRedirect = `${privateRoot}/DadosCadastrais`;
export const cadastroContribuinte = `${dadosCadastraisRedirect}/CadastrarContribuinte`;
export const editarContribuinte = `${dadosCadastraisRedirect}/EditarContribuinte`;
export const visualizarContribuinte = `${dadosCadastraisRedirect}/VisualizarContribuinte`;

export const signinRedirect = '/signin-redirect';
